<template>
    <div class="section_title" v-show="bottom_list.length >= 4">
        <p class="section_title_text">Latest News</p>
    </div>
    <category-list :cards="bottom_list" :imgHost="imgHost" :loading="loading"></category-list>
</template>

<script>
    import { loadMore } from '@vuePath/api/article';
    import CategoryList from '@componentPath/category/CategoryList';
    import { convertDateToFormat, stripLength } from '@vuePath/tools/tool';
    import { checkIsFreeArticle } from '@vuePath/tools/article';
    export default {
        props: {
            type: {
                type: String,
                required: true
            },
            typeId: {
                type: [String, Number],
                required: true
            },
            csrfToken: {
                type: String,
                required: true
            },
            imgHost: {
              type: String,
              required: true
            }
        },
        data() {
            return {
                bottom_list: [],
                page: 1,
                size: 12,
                refresh: 'false',
                last_scroll: 0,
                load_data: false,
                loading: false
            }
        },
        components: {
            CategoryList
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        async mounted() {
            await this.getData();
        },
        methods: {
            getData() {
                this.loading = true;
                return new Promise((resolve, reject) => {
                    loadMore(this.type, this.typeId, this.page, this.size, this.csrfToken).then((response) => {
                        let data = response.data.data;
                        this.refresh = data.refresh;

                        if (this.page === 1) {
                            this.bottom_list = data.data.slice(4);
                        } else {
                            if (this.refresh === 'false') {
                                this.bottom_list = this.bottom_list.concat(data.data);
                            } else {
                                this.bottom_list = data.data.slice(4);
                            }
                        }

                        if (data.data.length > 0) {

                            if (data.data.length < this.size) {
                                this.load_data = false;
                            } else {
                                this.load_data = true;
                            }
                        } else {
                            if (this.page > 1) {
                                this.page -= 1;
                            }
                        }
                        this.loading = false;
                        resolve(response);
                    }).catch((err) => {
                        reject(err);
                    });
                });
            },
            async updateData() {
                this.page += 1;
                this.load_data = false;
                await this.getData();
            },
            handleScroll() {
                if (this.load_data) {
                    this.last_scroll = window.pageYOffset;
                    let that = this;
                    window.requestAnimationFrame(function () {
                        let window_bottom = that.last_scroll + window.innerHeight;
                        let category_bottom = document.getElementById('vue_category').offsetTop
                            + document.getElementById('vue_category').clientHeight;
                        if (window_bottom > category_bottom) {
                            that.updateData();
                        }
                    });
                }
            },
            convertTimestampToFormat(timestamp) {
                return convertDateToFormat(timestamp);
            },
            checkIsFreeArticle(article) {
                return checkIsFreeArticle(article);
            },
            stripLength(content, length) {
                return stripLength(content, length);
            }

        }
    }
</script>
